var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('v-autocomplete',{attrs:{"items":_vm.statusTypes,"rules":[_vm.required],"item-text":"key","item-value":"value","outlined":"","label":"Status"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }